import type { ReopenCommentsThreadPayload, ResolveCommentsThreadPayload } from '@domain/schemas/payload.schema';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { ReopenCommentsThreadResponse, ResolveCommentsThreadResponse } from '@responses/comments';
import axios from 'axios';

import { queryClient } from '../utils/queryClient';

type PatchCommentData = ReopenCommentsThreadPayload | ResolveCommentsThreadPayload;
type PatchCommentResponse = ReopenCommentsThreadResponse | ResolveCommentsThreadResponse;

export const patchComment = async (data: PatchCommentData, submissionId: string): Promise<PatchCommentResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'patch',
    url: `submissions/${submissionId}/comments`,
    data,
  });

  const response = await axios(networkPayload);
  await queryClient.invalidateQueries({ queryKey: ['submissions'] });
  await queryClient.invalidateQueries({ queryKey: ['search'] });
  return response.data;
};
